import React from "react";
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Box } from "@mui/material";
import { AppStore } from "../../stores/AppStore";
import { MDBBtn } from "mdbreact";
import { UtilitarioStore } from "../../stores/utilitarios/UtilitarioStore";
import { AppIcon } from "../utils/AppIcon";

const Sidebar = ({ open, onClose, isOpen }) => {

  const toggleDrawer = (pathname: string) => {

    AppStore.setLocation(pathname)

    onClose()

  };

  const toggleOpen = () => {

    UtilitarioStore.obs.open_equaliza_ncm = true

    onClose()

  };

  // const toggleSubMenu = (item) => {

  //   setOpenSubMenu((prev) => ({ ...prev, [item]: !prev[item] }));

  // };

  const userAdmin = AppStore.obs1.usuario ? AppStore.obs1.usuario.admin : ""

  const menuItems = [
    { path: "/central-de-acoes", label: "Central de Ações", icon: "insert_chart" },
    { path: (userAdmin ? "/tarefas-admin" : "/tarefas"), label: "Gerenciamento de Tarefas", icon: "task" },
    { path: "/logs", label: "Logs", icon: "policy", restricted: true },
    { path: "/parcelamentos", label: "Parcelamentos", icon: "payments"}
  ];

  const isActive = (path) => AppStore.obs1.location.area === path.replace("/", "");

  return (
    <>

      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "100vh",
          width: "1px",
          zIndex: 9999999,
          background: "transparent"
        }}
        // onMouseEnter={() => isOpen()}
      />

      <Drawer anchor="left" open={open} onClose={onClose} sx={{ zIndex: 9999 }} PaperProps={{ onMouseLeave: onClose }}>

        <Box sx={{ display: "flex", flexDirection: "column", height: "100%", width: 250 }}>

          <List sx={{ flexGrow: 1 }}>

            {menuItems.map(({ path, label, icon: Icon, restricted }) => {

              return (
                <ListItem button key={path} onClick={() => toggleDrawer(path)}>
                  <ListItemIcon>
                    <AppIcon name={Icon} style={{ color: isActive(path) ? "#2b82bc" : "#3e6971" }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={label}
                    className={`item-sidebar ${isActive(path) ? "item-sidebar-actived" : ""}`}
                  />
                </ListItem>
              );

            })}

            {userAdmin ? <>
              <ListItem button onClick={() => toggleDrawer("/vnc")}>
                <ListItemIcon>
                  <AppIcon name="tv" style={{ color: isActive("/vnc") ? "#2b82bc" : "#3e6971" }} />
                </ListItemIcon>
                <ListItemText
                  primary="VNC"
                  className={`item-sidebar ${isActive("/vnc") ? "item-sidebar-actived" : ""}`} />
              </ListItem>

              <ListItem button onClick={() => toggleOpen()}>
                <ListItemIcon>
                  <AppIcon name="graphic_eq" style={{ color: isActive("/equaliza-ncm") ? "#2b82bc" : "#3e6971" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Equalização de NCMs"
                  className={`item-sidebar ${isActive("/equaliza-ncm") ? "item-sidebar-actived" : ""}`} />
              </ListItem>

              <ListItem button onClick={() => toggleDrawer("/monitorar-topics")}>
                <ListItemIcon>
                  <AppIcon name="tv" style={{ color: isActive("/monitorar-topics") ? "#2b82bc" : "#3e6971" }} />
                </ListItemIcon>
                <ListItemText
                  primary="Monitorar Tópicos"
                  className={`item-sidebar ${isActive("/monitorar-topics") ? "item-sidebar-actived" : ""}`} />
              </ListItem>

            </>

              : <></>}

          </List>

          {/* <ListItem button onClick={() => toggleSubMenu("utils")}>
            <ListItemIcon><PersonalVideoIcon /></ListItemIcon>
            <ListItemText primary="Utilitários" />
            {openSubMenu["utils"] ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={openSubMenu["utils"]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button style={{ paddingLeft: 40 }} onClick={onClose}>
                <ListItemIcon>
                  <PersonalVideoIcon sx={{ color: isActive("/equaliza-ncm") ? "#2b82bc" : "#3e6971" }} />
                </ListItemIcon>
                <ListItemText primary="Equalização de NCMs" className={`item-sidebar ${isActive("/equaliza-ncm") ? "item-sidebar-actived" : ""}`} />
              </ListItem>
            </List>
          </Collapse> */}

          <Box sx={{ position: "absolute", bottom: 0, p: 2, width: 250, textAlign: "center", borderTop: "1px solid rgba(27, 99, 111, 0.15)" }}>

            <MDBBtn className="btnDefault" onClick={() => window.open("http://help.fipo.com.br/", "_blank")}>
              Dúvidas? Acesse a Central de Ajuda
            </MDBBtn>

          </Box>

        </Box>

      </Drawer >

    </>

  );
};

export default Sidebar;
